import { useId } from "react";
import twitterText from "twitter-text";
import BannerMobile from "./BannerMobile";
import { ButtonWithInputFile } from "./ButtonWithInputFile";
import Thumbnails from "./Thumbnails";

const Input = (props) => {
  const textAreaId = useId();
  const textLength = [...props.text].length;
  const parsedTweet = twitterText.parseTweet(props.text);

  const copyToClipboard = async () => {
    await global.navigator.clipboard.writeText(props.text);
    alert("テキストをコピーしました");
  };

  //新しいタブで開く
  const handleClickPostToX = () => {
    window.open(
      `https://x.com/compose/post?text=${encodeURIComponent(props.text)}`,
      "_blank",
    );
  };

  const handleClickPostToThreads = () => {
    window.open(
      `https://www.threads.net/intent/post?text=${encodeURIComponent(
        props.text,
      )}`,
      "_blank",
    );
  };

  const kanjiRate = (
    Math.round((props.kanji / textLength) * 10000) / 100
  ).toFixed(2);

  return (
    <div className="h-auto w-full flex-row px-6 py-4 lg:w-2/3 lg:max-w-[1300px]">
      <h2 className="mb-2 text-[20px] font-bold text-gray-900">
        テキストを入力してください
      </h2>
      <textarea
        id={textAreaId}
        text={props.text}
        value={props.value}
        onChange={(e) => {
          e.stopPropagation();
          e.preventDefault();
          props.onChange(e);
          // 改行に合わせて高さを変える
          e.target.style.height = `${e.target.scrollHeight}px`;
        }}
        className="
          bg-white-50
          mb-2
          h-auto
          min-h-48
          w-full
          text-wrap
          rounded-lg
          border
          border-gray-300
          p-2
          text-base
          text-gray-900
          focus:border-blue-200
          focus:bg-yellow-100
          focus:ring-blue-100
          sm:p-2.5
        "
        placeholder="いまどうしてる？"
      />

      <div className="flex flex-wrap items-center justify-end gap-2">
        <ButtonWithInputFile
          aria-label="画像を選択"
          inputProps={{
            type: "file",
            accept: "image/png",
            onChange: props.onFileSelect,
          }}
        >
          <span
            className="
              icon-[fa6-regular--image]
              inline-block
              h-4
              w-4
              text-white
              sm:mr-1
            "
          />
          <span className="hidden text-white sm:inline">画像</span>
        </ButtonWithInputFile>
        <button
          type="button"
          className="
            inline-flex
            h-10
            w-10
            items-center
            justify-center
            rounded-lg
            bg-gray-300
            px-0
            py-2
            text-xs
            font-medium
            text-black
            hover:bg-gray-200
            active:bg-gray-400
            dark:bg-gray-300
            dark:hover:bg-gray-200
            dark:focus:ring-gray-800
            sm:w-32
            sm:px-4
          "
          style={{ WebkitAppearance: "none", appearance: "none" }}
          aria-label="テキストをクリア"
          onClick={props.deleteText}
        >
          <span
            className="
            icon-[ph--eraser-light]
            inline-block
            h-4
            w-4
            sm:mr-1
          "
          ></span>
          <span className="hidden sm:inline">クリア</span>
        </button>
        <button
          type="button"
          className="
            inline-flex
            h-10
            w-10
            items-center
            justify-center
            rounded-lg
            bg-green-700
            px-0
            py-2
            text-xs
            font-medium
            text-white
            hover:bg-green-600
            active:bg-green-800
            dark:bg-green-600
            dark:hover:bg-green-700
            dark:focus:ring-green-800
            sm:w-32
            sm:px-4
          "
          style={{ WebkitAppearance: "none", appearance: "none" }}
          aria-label="テキストをコピー"
          onClick={() => copyToClipboard()}
        >
          <span
            className="
            icon-[ph--copy]
            inline-block
            h-4
            w-4
            sm:mr-1
          "
          ></span>
          <span className="hidden sm:inline">コピー</span>
        </button>
        <div className="flex gap-2">
          <button
            type="button"
            className="
              inline-flex
              h-10
              w-auto
              items-center
              justify-center
              rounded-lg
              bg-black
              px-3
              py-2
              text-xs
              font-medium
              text-white
              hover:bg-gray-800
              active:bg-gray-900
              dark:bg-black
              dark:hover:bg-gray-700
              dark:focus:ring-gray-800
              sm:w-32
              sm:px-4
            "
            style={{ WebkitAppearance: "none", appearance: "none" }}
            onClick={() => handleClickPostToX()}
          >
            <span className="text-sm text-white">𝕏</span>
          </button>
          <button
            type="button"
            className="
              inline-flex
              h-10
              w-auto
              items-center
              justify-center
              rounded-lg
              border-2
              border-black
              bg-white
              px-3
              py-2
              text-xs
              font-medium
              text-black
              hover:bg-gray-50
              active:bg-gray-100
              dark:border-white
              dark:bg-white
              dark:text-black
              dark:hover:bg-gray-200
              dark:focus:ring-gray-800
              sm:w-32
              sm:px-4
            "
            style={{ WebkitAppearance: "none", appearance: "none" }}
            onClick={() => handleClickPostToThreads()}
          >
            <span className="text-sm text-black">Threads</span>
          </button>
        </div>
      </div>

      <Thumbnails
        activeItem={props.activeItem}
        setActiveItem={props.setActiveItem}
        photoOrder={props.photoOrder}
        images={props.images}
        onDeleteImage={() => props.onDeleteImage()}
        onDragStart={props.onDragStart}
        onDragEnd={props.onDragEnd}
        onDragCancel={props.onDragCancel}
      />

      <h2 className="mb-2 mt-4 text-[20px] font-bold text-gray-900">
        文字カウント・構成比率
      </h2>
      <div className="rounded-md bg-gray-100 p-2 text-[14px]">
        <div className="flex items-center justify-between px-1">
          <p className="w-48 text-[14px] ">テキスト文字数：</p>
          <div>
            <span className="mr-1 text-[25px] font-bold">{textLength}</span>
            <span className="m-1 inline-block w-8 text-right">文字</span>
          </div>
        </div>

        <div className="flex items-center justify-between px-1">
          <p className="w-48">X（Twitter）上の文字数：</p>
          <div>
            <span
              className={`
                mr-1
                text-right
                text-[25px]
                font-bold
                ${parsedTweet.weightedLength / 2 > 140 ? "text-red-600" : ""}
              `}
            >
              {parsedTweet.weightedLength / 2}
            </span>
            <span className="m-1 inline-block w-8 text-right">文字</span>
          </div>
        </div>
        <div
          className={`flex items-center justify-between px-1 ${kanjiRate >= 30 ? "text-red-600" : "text-black"}`}
        >
          <p>漢字比率：</p>
          <div>
            <div className="">
              <span className="mr-1 text-[25px] font-bold">
                {props.text ? kanjiRate : "-"}
              </span>
              <span className="m-1 inline-block w-8 text-right">%</span>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between px-1">
          <p>ひらがな比率：</p>
          <div>
            <span className="mr-1 text-[25px] font-bold">
              {props.text
                ? (
                    Math.round((props.hiragana / textLength) * 10000) / 100
                  ).toFixed(2)
                : "-"}
            </span>
            <span className="m-1 inline-block w-8 text-right">%</span>
          </div>
        </div>
        <div className="flex items-center justify-between px-1">
          <p>全角カタカナ比率：</p>
          <div>
            <span className="mr-1 text-[25px] font-bold">
              {props.text
                ? (
                    Math.round((props.fullKatakana / textLength) * 10000) / 100
                  ).toFixed(2)
                : "-"}
            </span>
            <span className="m-1 inline-block w-8 text-right">%</span>
          </div>
        </div>
        <div className="flex items-center justify-between px-1">
          <p>英数字（半角）比率：</p>
          <div>
            <span className="mr-1 text-[25px] font-bold">
              {props.text
                ? (
                    Math.round((props.halfAlphanumeric / textLength) * 10000) /
                    100
                  ).toFixed(2)
                : "-"}
            </span>
            <span className="m-1 inline-block w-8 text-right">%</span>
          </div>
        </div>
        <div className="flex items-center justify-between px-1">
          <p>英数字（全角）比率：</p>
          <div>
            <span className="mr-1 text-[25px] font-bold">
              {props.text
                ? (
                    Math.round((props.fullAlphanumeric / textLength) * 10000) /
                    100
                  ).toFixed(2)
                : "-"}
            </span>
            <span className="m-1 inline-block w-8 text-right">%</span>
          </div>
        </div>
        <div className="flex items-center justify-between px-1">
          <p className="">その他（句読点など）比率：</p>
          <div>
            <span className="mr-1 text-[25px] font-bold">
              {props.text
                ? (
                    Math.round((props.other / textLength) * 10000) / 100
                  ).toFixed(2)
                : "-"}
            </span>
            <span className="m-1 inline-block w-8 text-right">%</span>
          </div>
        </div>
        <div className="flex items-center justify-between p-1">
          <p className="w-48">リンク数：</p>
          <div>
            <span className="mr-1 text-[25px] font-bold">
              {twitterText.extractUrls(props.text).length}
            </span>
            <span className="m-1 inline-block w-8 text-right">個</span>
          </div>
        </div>
      </div>
      <BannerMobile isDisplayed={props.isMobile} />
      <h2 className="mr-1 mt-8 text-[19px] font-bold text-gray-900 sm:text-[20px]">
        ※X上での文字数カウントのルール
      </h2>
      <ul className="w-full rounded-md border bg-green-100 px-4 py-2">
        <li>
          半角文字：<span className="font-bold">0.5</span>文字
        </li>
        <li>
          全角文字：<span className="font-bold">1</span>文字
        </li>
        <li>
          改行：<span className="font-bold">0.5</span>文字
        </li>
        <li>
          URL：<span className="font-bold">11.5</span>文字
        </li>
      </ul>
      <p className="mt-2">でカウントされます</p>
    </div>
  );
};

export default Input;
